export default __webpack_public_path__ + "static/media/Stefania Scateni e Diana Agostinello.0b761aa6.jpg";